// src/components/EmptyState/EmptyState.js
import styled from "styled-components";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";

const EmptyStateWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 60px 20px;
  text-align: center;
  color: #ccc;

  svg {
    font-size: 80px;
    color: #888;
  }

  h3 {
    font-size: 1.5rem;
    font-weight: 500;
    color: #fff;
  }

  p {
    max-width: 400px;
    font-size: 1rem;
    color: #aaa;
  }
`;

export default function EmptyState({ title, message }) {
    return (
        <EmptyStateWrapper
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
        >
            <Icon icon="solar:box-bold-duotone" />
            <h3>{title}</h3>
            <p>{message}</p>
        </EmptyStateWrapper>
    );
}
